var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"delete-button",class:_vm.variant == 'primary' ? 'button-blue' : 'button-danger'},[_c('i',{staticClass:"fa fa-trash delete-icon",class:_vm.variant == 'primary' ? 'icon-blue' : 'icon-danger'})])
}
var staticRenderFns = []

export { render, staticRenderFns }